import React from 'react'
import { getReservationsList } from '../../services/reservations/getReservations';
import Spinner from "../../components/Spinner/Spinner";
import { Container, HeaderWrapper, MainHeader } from './styles';
import { Button, Divider } from '@mui/material';
import { StickyTable } from '../../components/StickyTable';
import { NullDescription, NullMessage, NullPage } from '../Reservations/styles';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../routes/constants';
import theme from '../../theme/theme';

export const History = () => {
  const navigate = useNavigate();

  // ------------------- JWT -------------------
  const jwt = localStorage.getItem('jwt');
  const userType = localStorage.getItem('user_type');

  // ------------------- STATES -------------------
  const [reservationListData, setReservationListData] = React.useState<any>(null);
  const [loadingReservationList, setLoadingReservationList] = React.useState(false);
  const [reservationList, setReservationList] = React.useState<any>(null);

  // ------------------- USE EFFECT -------------------
  React.useEffect(() => {
    setLoadingReservationList(true);
    getReservations();
  }, []);

  React.useEffect(() => {
    reservationList && handleData();
  }, [reservationList]);

  // ------------------- GET RESOURCES FROM API -------------------

  const getReservations = async () => {
    try {
      const statuses = ["Completed", "In Progress", "Approved", "Modified", "Not available", "Rejected", "Canceled", "Expired"];
      const allReservations: any[] = [];

      for (const status of statuses) {
        const res = await getReservationsList(jwt!, status, "", "");
        if (res && res.data && res.data.length > 0) {
          allReservations.push(...res.data);
        }
      }

      if (allReservations.length > 0) {
        allReservations.sort((a, b) => new Date(b.start).getTime() - new Date(a.start).getTime());
        setReservationList(allReservations);
        handleData();
      }      
    } catch (err) {
      // Manejar el error aquí
    } finally {
      setLoadingReservationList(false);
    }
  };

  // ------------------- TABLE PARAMS -------------------
  const historyCols = [
    { id: 'resource_name', label: 'Recurso', minWidth: 170 },
    { id: 'start', label: 'Inicio', minWidth: 170 },
    { id: 'finish', label: 'Fin', minWidth: 170 },
    { id: 'status', label: 'Estado', minWidth: 170 },
  ]

  // ------------------- HANDLE DATA -------------------
  const handleData = () => {
    if (reservationList) {
      const reservationListRows = reservationList.map((reservation: any) => ({
        resource_name: reservation.resource_name,
        start: handleDate(reservation.start),
        finish: handleDate(reservation.finish),
        status: handleStatus(reservation.status),
      }));

      setReservationListData(reservationListRows);
    }
  };

  const handleDate = (date: string) => {
    const myDate = new Date(date).toLocaleDateString('es-MX');
    const myTime = new Date(date).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', hour12: true, timeZone: 'America/Mexico_City' });
    return myDate + "\n" + myTime;
  }

  const statusMapping: { [key: string]: string } = {
    "Completed": "Completada",
    "In Progress": "En progreso",
    "Pending": "Pendiente",
    "Approved": "Aprobada",
    "Not available": "No disponible",
    "Rejected": "Denegada",
    "Canceled": "Cancelada",
    "Modified": "Modificada",
    "Expired": "Vencida",
};

  const handleStatus = (reservationStatus: string): string => {
    return statusMapping[reservationStatus] || "Desconocido";
  };

  return (
    <>
      {loadingReservationList ? (
        <Spinner />
      ) : (
        <Container>
          <MainHeader>Mi historial</MainHeader>
          <HeaderWrapper>
            {/* Aquí puedes agregar cualquier contenido que necesites */}
          </HeaderWrapper>
          <Divider sx={{ marginBottom: '20px' }} />
          {reservationListData && reservationList.length > 0 ? (
            <StickyTable columns={historyCols} rows={reservationListData} />
          ) : (
            <NullPage>
              <NullMessage>No tienes reservaciones</NullMessage>
              <NullDescription>
                Puedes reservar recursos desde nuestra página de inicio
              </NullDescription>
              <Button
                variant="contained"
                onClick={() => navigate(`${ROUTES.RESERVE}`)}
                sx={{
                  borderRadius: "12px",
                  backgroundColor: theme.color.stone,
                  padding: "5px 3%",
                  marginRight: "15px",
                  color: "#FFF",
                  textTransform: "none",
                  marginTop: "30px",
                  fontSize: "1.05rem",
                  "&:hover": {
                    backgroundColor: theme.color.navy,
                  },
                }}
              >
                Reservar
              </Button>
            </NullPage>
          )}
        </Container>
      )}
    </>
  );
  

}

export default History
